module.exports = __webpack_public_path__ + "img/productBgImg4.2773d942.png";